import { asset } from "@/lib/asset";
const cards = [
    {
        id: 1,
        title: 'Мониторинга работы приложений в реальном времени.',
        image: asset('/img/apm/apm-monitoring.png')
    },
    {
        id: 2,
        title: 'Поиска и устранения причин сбоев и замедлений.',
        image: asset('/img/apm/apm-search.png')
    },
    {
        id: 3,
        title: 'Улучшения пользовательского опыта за счет анализа взаимодействия с сервисом.',
        image: asset('/img/apm/apm-users.png'),
    },
    {
        id: 4,
        title: 'Оценки влияния инфраструктуры на производительность сервисов.',
        image: asset('/img/apm/apm-score.png'),
    }   
]

const CenterBlock = () => {
    return (
        <div className="w-full xl:w-[280px] h-auto xl:h-[170px] relative items-center justify-center hidden xl:flex">
            {/* top left circle */}
            <div className="w-2 h-2 top-[-166px] left-0 absolute bg-[#ffd38e] rounded-full border border-[#ffd38e]" />
            {/* top right circle */}
            <div className="w-2 h-2 top-[-166px] right-0 absolute bg-[#ffd38e] rounded-full border border-[#ffd38e]"  />

            {/* top horizontal line  */}
            <div className="absolute top-[-163px] w-full h-auto xl:h-[2px] bg-[#ffd38e]" />
            {/* bottom horizontal line  */}
            <div className="absolute top-0 xl:top-[330px] w-full h-auto xl:h-[2px] bg-[#ffd38e]" />
            
            {/* top vertical line  */}
            <div className="absolute top-[-160px] w-full xl:w-[2px] h-auto xl:h-[160px] bg-[#ffd38e]" />
            {/* bootom vertical line  */}
            <div className="absolute bottom-[-160px] w-full xl:w-[2px] h-auto xl:h-[160px] bg-[#ffd38e]" />
            
            {/* inner circle */}
            <div className="w-full xl:w-[170px] h-auto xl:h-[170px] absolute rounded-full border border-[#ffd38e]" /> 
            {/* outer circle */}
            <div className="w-full xl:w-[30px] h-auto xl:h-[30px] absolute bg-[#ffd38e] rounded-full border border-[#ffd38e]" />

            
            {/* bottom left circle */}
            <div className="w-2 h-2 left-0 top-0 xl:top-[327px] absolute bg-[#ffd38e] rounded-full border border-[#ffd38e]" />
            {/* bottom right circle */}
            <div className="w-2 h-2 right-0 top-0 xl:top-[327px] absolute bg-[#ffd38e] rounded-full border border-[#ffd38e]" />

        </div>
    )
}

const CardBlock = (card) => {
    return (
        <div className="w-full h-auto xl:h-[254px] flex-col justify-center items-center gap-[40px] lg:gap-5 inline-flex mb-[40px] lg:mb-0">

            <img className="w-full xl:w-[446px] h-auto xl:h-[217px] rounded-[10px] " src={card.image} />
            <div className="w-full md:w-[420px] xl:w-[446px] grow shrink basis-0 text-center text-white text-[10px] lg:text-base font-semibold font-['Open Sans']">{card.title}</div>
        </div>
    )
}

const UniqueKA = () => {
    return (
        <div className="w-full xl:w-[1403px] h-auto xl:h-[829px] lg:relative lg:flex justify-center items-center">

            <div className="h-auto xl:h-[829px] xl:left-0 xl:top-0 xl:absolute flex flex-col justify-center xl:justify-start items-center gap-10 ">
                
                <div className="h-11 flex-col justify-start items-center gap-5 flex">
                    <div className="self-stretch text-center text-[#ffd38e] text-[24px] lg:text-[32px] leading-normal xl:text-[32px] xl:leading-[44.8px] font-bold font-['Open Sans'] "> Особенности «Ключ-Астром»</div>
                </div>

                <div className="w-full w-md-[90%] xxl:w-[1370px] h-auto xl:h-[745px] flex flex-col inline-flex justify-center items-center gap-5 flex px-[23px]">

                    <div className="h-auto w-full xl:w-auto xl:h-[254px] justify-start items-start gap-2 xl:gap-[500px] inline-flex flex-col lg:flex-row  ">
                        {cards.slice(0, 2).map((card) => (
                            <CardBlock key={card.id} {...card} />
                        ))}
                    </div>

                    <CenterBlock />

                    <div className="h-auto w-full xl:w-auto xl:h-[254px] justify-start items-start gap-2 xl:gap-[500px] inline-flex flex-col lg:flex-row ">
                        {cards.slice(2, 4).map((card) => (
                            <CardBlock key={card.id} {...card} />
                        ))}
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default UniqueKA;    